import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { MoreOptions } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  dropdownContent?: ReactNode;
  left?: boolean;
  onClose?: () => void;
  title: string;
}

const ReaderSidebarHeader = ({
  dropdownContent,
  left,
  onClose,
  title
}: Props) => {
  const {
    messages,
    pageState: { readerTheme },
    theme
  } = useReduxState();

  return (
    <div className="header">
      <div className="title">{title}</div>
      <div className="actions">
        {dropdownContent ? (
          <div className="dropdown">
            <MoreOptions>{dropdownContent}</MoreOptions>
          </div>
        ) : null}
        <button
          aria-label={messages.commonClose}
          className="close focus-box-shadow"
          onClick={onClose}
        >
          <Icon icon="times" style={{ fontSize: '1.6rem' }} />
        </button>
      </div>

      <style jsx>{`
        .header {
          background-color: ${readerTheme?.sidebarHeaderBackgroundColor};
          border-bottom: 1px solid
            ${readerTheme?.sidebarHeaderBorderColor ||
            readerTheme?.sidebarHeaderBackgroundColor};
          border-radius: ${left ? '0 5px 0 0' : '5px 0 0 0'};
          color: ${readerTheme?.sidebarHeaderColorActive};
          padding: 10px 15px;
          position: relative;
        }
        .title {
          color: inherit;
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 1.6rem;
          font-weight: 700;
          margin: 0;
          padding-right: 30px;
        }
        .actions {
          flex-grow: 0;
          flex-shrink: 0;
        }
        .dropdown {
          position: absolute;
          top: 7px;
          right: 42px;
        }
        .dropdown :global(.toggle) {
          background-color: transparent;
          border: 0;
          border-radius: 50%;
          color: ${readerTheme?.sidebarHeaderColor};
          cursor: pointer;
          font-size: 1.6rem;
          height: 30px;
          margin: 0;
          outline: 0;
          padding: 0;
          position: relative;
          text-align: center;
          transition: color 0.3s;
          width: 30px;
        }
        .dropdown :global(.toggle:focus),
        .dropdown :global(.toggle:hover),
        .dropdown :global(.toggle.active) {
          background-color: transparent;
          color: ${readerTheme?.sidebarHeaderColorActive};
        }
        .close {
          background-color: transparent;
          border: 0;
          border-radius: ${theme.cardBorderRadius};
          color: ${readerTheme?.sidebarHeaderColor};
          cursor: pointer;
          display: inline-block;
          margin: 0;
          outline: 0;
          padding: 8px 10px 7px;
          position: absolute;
          right: 7px;
          top: 5px;
          transition: color 0.3s;
        }
        .close:active,
        .close:hover {
          color: ${readerTheme?.sidebarHeaderColorActive};
        }
        .close:focus {
          box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.15);
        }
        @media (min-width: ${breakpoints.medium}px) {
          .header {
            border-radius: ${`${theme.cardBorderRadius} ${theme.cardBorderRadius} 0 0`};
          }
        }
      `}</style>
    </div>
  );
};

export default ReaderSidebarHeader;
